<div class="purple-box" *ngIf="!displaySuccessModel">
    <h3 class="hidden-xs">FedEx Supply Chain Registration Page</h3>

    <form [formGroup]="registrationFormGroup" class="form" novalidate>

        <app-notification *ngIf="displayFailureNotification" notificationTitle=""
            notificationBodyContent="Unfortunately there was an internal issue. Please retry, if you are still facing issue - please report an issue"
            notificationType='FULL_INLINE_ERROR' [dislayCloseButton]="true" [displayLeaveButton]="false"
            [displayStayButton]="false" (closeNotificationEvent)="handleCloseErrorEvent()"></app-notification>

        <app-notification *ngIf="displayErrorNotification" notificationTitle="" [notificationBodyContent]="errorMessage"
            notificationType='FULL_INLINE_ERROR' [dislayCloseButton]="true" [displayLeaveButton]="false"
            [displayStayButton]="false" (closeNotificationEvent)="handleCloseErrorEvent()"></app-notification>

        <div class="purple-radio-group">
            <div class="row fdx-u-mt--3">
                <div class="col-md-6 col-sm-12 fdx-u-mb--2">
                    <div class="fdx-c-form-group fdx-c-form-group--radio">
                        <input type="radio" id="check1" value="V" aria-describedby="me-1"
                            class="fdx-c-form-group__radio" aria-labelledby="check1" formControlName="type">
                        <label class="fdx-c-form-group__label fdx-c-form-group__label__trunc fdx-u-color--white" for="check1"
                            id="check1">Vendor</label>
                    </div>
                </div>
                <div class="col-md-6 col-sm-12 fdx-u-mb--2">
                    <div class="fdx-c-form-group fdx-c-form-group--radio">
                        <input checked type="radio" id="check2" value="C" aria-describedby="me-2"
                            class="fdx-c-form-group__radio" aria-labelledby="check2" formControlName="type">
                        <label class="fdx-c-form-group__label fdx-c-form-group__label__trunc fdx-u-color--white" for="check2"
                            id="check2">Customer</label>
                    </div>
                </div>
            </div>
        </div>


        <div class="white-bg">

            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <span class="fdx-c-eyebrow  fdx-c-eyebrow--small" style="color:black">{{user.loginId}}</span>
                </div>
            </div>
            <div class="row fdx-u-mt--4">
                <div class="col-md-12 col-sm-12 fdx-u-mb--2">
                    <div class="fdx-c-form-group fdx-c-form-group--float-label" [ngClass]="{'fdx-c-form-group--is-invalid':(!companyId.valid && companyId.touched && companyId.hasError('required')),
                                     'fdx-c-form-group--has-value': (companyId.value!==null&&companyId.value!=='')}">
                        <div class="fdx-c-form-group__item">
                            <input type="text" class="fdx-c-form-group__input" formControlName="companyId"
                                maxlength="50" aria-describedby="companyId">
                            <label class="fdx-c-form-group__label fdx-c-form-group__label__trunc fdx-c-form-group__label--dark">
                                Customer Code
                            </label>
                        </div>
                        <div role="alert" class="fdx-c-form-group__message fdx-c-form-message--error"
                            *ngIf="!companyId.valid && companyId.touched">
                            {{ requiredMessage }}
                        </div>
                    </div>
                </div>

                <!--<div class="col-md-12 col-sm-12">
                    <div class="fdx-c-form-group fdx-c-form-group--float-label"
                        [ngClass]="{'fdx-c-form-group--is-invalid':(!businessUnitNames.valid && businessUnitNames.touched && businessUnitNames.hasError('required')),
                                     'fdx-c-form-group--has-value': (businessUnitNames.value!==null&&businessUnitNames.value!=='')}">
                        <div class="fdx-c-form-group__item">
                            <input type="text" class="fdx-c-form-group__input" formControlName="businessUnitNames"
                                maxlength="50" aria-describedby="businessUnitNames">
                            <label class="fdx-c-form-group__label fdx-c-form-group__label__trunc fdx-c-form-group__label--dark">
                                Business Unit Names
                            </label>
                        </div>
                        <div role="alert" class="fdx-c-form-group__message fdx-c-form-message--error"
                            *ngIf="!businessUnitNames.valid && businessUnitNames.touched">
                            {{ requiredMessage }}
                        </div>
                    </div>
                </div> -->

            </div>

            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <div class="fdx-u-mt--4 fdx-u-mb--4 float-right-til-md">
                        <button class="fdx-c-button fdx-c-button--text fxg-margin-right" (click)="onCancel()">
                                CANCEL
                        </button>    
                        <a (click)="onSubmit()"
                            class="fdx-c-button fdx-c-button--primary fdx-c-button--responsive">Register</a>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>


<div class="fdx-c-modal" *ngIf="displaySuccessModel">
    <div class="fdx-c-modal__backdrop"></div>
    <div class="fdx-c-modal__main  fdx-c-modal__main--medium">
        <div class="fdx-c-modal__body">
            <h3 class="fdx-c-modal__title">Registration Successful</h3>
            <div class="fdx-c-modal__description">
                <div class="row">
                    <div class="col">
                        Your registration was successful, once approved you are able to login
                    </div>
                </div>
                <div class="row align-items-center fdx-u-mt--4">
                    <div class="col"></div>
                    <div class="col">
                        <a (click)="onCancel()"
                            class="fdx-c-button fdx-c-button--primary-outline fdx-c-button--responsive mr-4 marg-btm-15-at-md">Close</a>
                    </div>
                    <div class="col"></div>
                </div>
            </div>
        </div>
        <div class="fdx-c-modal__footer">
            <button class="fdx-c-modal__footer__button fdx-c-button fdx-c-button--icon"
                aria-label="close modal message: lorem ipsum" (click)="onCancel()">
                <div class="none">
                    <svg class="fdx-c-icon" aria-hidden="true" focusable="false" role="presentation">
                        <use xlink:href="#cross"></use>
                    </svg>
                </div>
            </button>
        </div>
    </div>
</div>